/**
 * PLAYER TRANSACTIONS -- ACTIONS
 * @description
 * [ACTIONS] - This are the list of actions for the player transactions module
 */
const ActionTypes = {
  GET_ALL_PLAYER_TRANSACTIONS: 'transactions/player/getAll',
  GET_FILTER_OPTIONS: 'transactions/player/getFilterOptions',
}

export default ActionTypes
